import { ContentUnitFactory } from '../factories/ContentUnitFactory';
import { UNIT } from '../../../constants/size';

const THREE = require('three');

class SectionView extends THREE.Group {
    constructor(sectionData, webgl, navShift = 0) {
        super();

        const { id, name } = sectionData;

        this.sectionData = sectionData;
        this.name = name;

        this.sectionId = id;
        this.isInside = false;
        this._navShift = navShift;
        this._enabled = false;

        this._constructUnits(webgl);
        this._updateEnabled();
    }

    _constructUnits(webgl) {
        const unitsView = this.sectionData.units.map((unitData) => ContentUnitFactory.create(unitData.type, unitData, webgl));

        let zIterate = 0;

        unitsView.forEach((unitView) => {
            // Add unit next to the previous one
            unitView.position.z = -zIterate;
            this.add(unitView);

            // Set next unit position
            zIterate += unitView.zSize;
        });

        this.units = unitsView;
    }

    checkNavigationChanged(camera) {
        if (!camera) return { changed: false };

        const mtx = this.matrixWorld;
        const worldPosition = new THREE.Vector3();

        worldPosition.setFromMatrixPosition(mtx);

        const z = worldPosition.z - camera.position.z;
        const startZ = (-0.101 + this._navShift) * UNIT.zSize - UNIT.camDistance;
        const newValue = z >= startZ && z < startZ + this.zSize;
        const changed = this.isInside !== newValue;

        this.isInside = newValue;

        return {
            changed,
            direction: z < startZ ? -1 : 1,
            isInside: newValue,
            sectionId: this.sectionId
        };
    }

    updateEnableState(camera) {
        if (!camera) return;

        const mtx = this.matrixWorld;
        const worldPosition = new THREE.Vector3();

        worldPosition.setFromMatrixPosition(mtx);

        const z = worldPosition.z - camera.position.z;
        const startZ = (-0.101 + this._navShift) * UNIT.zSize - UNIT.camDistance;
        const newValueIsInside = z >= -UNIT.camFar && z < startZ + this.zSize;

        if (this._enabled === newValueIsInside) return;

        this._enabled = newValueIsInside;
        this._updateEnabled();
    }

    _updateEnabled() {
        if (!this.units) return;

        this.units.forEach((unit) => {
            unit.enabled = this._enabled;
        });
        this.visible = this._enabled;
    }

    get zSize() {
        return this.sectionData.weight * UNIT.zSize;
    }
}

export default SectionView;
